<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1100"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="划拨"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 15 }"
          @submit="handleSubmit"
        >
          <a-col :span="12">
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-textarea
                :rows="20"
                :placeholder="eidPlaceholder"
                :style="{ color: eidValidateStatus === 'error' ? 'red' : '' }"
                v-model.trim="eidInput"
                @blur="analyzeEidInput"
              />
              <div style="margin-top: 8px">
                <span>EID总数：{{ input_esims_count }}</span>
                <span style="margin-left: 24px">重复数量：{{ duplicate_count }}</span>
              </div>
              <div v-if="eidErrorMsg" style="color: red; margin-top: 4px">{{ eidErrorMsg }}</div>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="项目eSIM数(张)">
              <span>{{ data.item_cards_count }}</span>
            </a-form-item>

            <a-form-item label="已划拨eSIM数(张)">
              <span>{{ data.allocated_cards_count }}</span>
            </a-form-item>

            <a-form-item label="输入eSIM总数(张)">
              <span>{{ input_esims_count }}</span>
            </a-form-item>

            <a-form-item label="备注">
              <a-textarea
                :rows="3"
                v-decorator="['remark', {
                  rules: [
                    { max: 200, message: '最多200个字符' },
                  ]
                }]"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { allocateEsimsToTopAgent, findAgentPurchaseItemAllocationInfo } from '@/api/agent_purchase_item'
import { analyzeEids, maxEidLines } from '@/utils/eid'

export default {
  name: 'AllocateEsimsToTopAgent',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    agentPurchaseItemId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {
        item_cards_count: 0,
        allocated_cards_count: 0
      },
      eidInput: '',
      input_esims_count: 0,
      duplicate_count: 0,
      parsedEids: [],
      eidValidateStatus: '',
      eidErrorMsg: '',
      eidPlaceholder: '可以直接复制excel中整列EID；\n' +
        '手动输入多个EID，一行一个，EID固定32位；\n' +
        '连号的EID只需要输入最后几位不一样的即可，用波浪线连接。\n' +
        '例如: 89049032005008820000000000000100~150',
      form: this.$form.createForm(this, { name: 'allocate_esims' }),
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findAgentPurchaseItemAllocationInfo(this.agentPurchaseItemId).then((res) => {
        if (res.code === 0) {
          this.data = res.data
        }
      })
    },

    analyzeEidInput() {
      if (!this.eidInput) {
        this.parsedEids = []
        this.input_esims_count = 0
        this.duplicate_count = 0
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '请输入 EID'
        return
      }

      const { lines, validEids, errorText } = analyzeEids(this.eidInput)
      if (lines > maxEidLines) {
        this.parsedEids = []
        this.input_esims_count = 0
        this.duplicate_count = 0
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = `EID数量不能超过${maxEidLines}`
        return
      }

      this.eidInput = errorText + validEids.join('\n')
      this.parsedEids = this.$lodash.uniq(validEids)
      this.input_esims_count = validEids.length
      this.duplicate_count = validEids.length - this.parsedEids.length

      if (errorText) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '号码包含错误，无法提交（EID须为32位）'
      } else if (this.parsedEids.length === 0) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '请输入 EID'
      } else if (this.duplicate_count > 0) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = '录入的 EID 存在重复'
      } else if (this.input_esims_count + this.data.allocated_cards_count > this.data.item_cards_count) {
        this.eidValidateStatus = 'error'
        this.eidErrorMsg = 'eSIM数量超过项目要求'
      } else {
        this.eidValidateStatus = 'success'
        this.eidErrorMsg = ''
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.analyzeEidInput()
      if (this.eidValidateStatus === 'error') {
        return
      }

      this.form.validateFields((err, values) => {
        if (err) return

        const eids = this.parsedEids
        if (eids.length === 0) {
          this.$warning({ title: '请输入有效 EID' })
          return
        }

        this.submitting = true
        allocateEsimsToTopAgent(this.agentPurchaseItemId, {
          eids,
          remark: values.remark
        }).then((res) => {
          this.submitting = false
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (
                <div>
                  <p>操作成功，具体操作结果请至 【系统查询】-【批量操作查询】 查看</p>
                </div>
              )
            })
          }
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>
